import React from "react";
import { Box, IconButton, InputBase, SxProps } from "@mui/material";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";

import type { UseToggleReturn } from "@utilifeed/hooks";

import { FontAwesomeSvgIcon } from "./FontAwesomeSvgIcon";

export type SearchToggleProps = UseToggleReturn & {
  placeholder?: string;
  sx?: SxProps;
};

/**
 * UI component implementing the common toggled-search pattern
 */
export const SearchToggle: React.FC<SearchToggleProps> = ({
  open,
  value,
  setOpen,
  setValue,
  placeholder = "Search",
  sx = {},
}) => {
  return (
    <Box sx={[{ position: "relative" }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
      {!open ? (
        <IconButton
          aria-label="search"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: "background.paper", color: "primary.main" }}
        >
          <FontAwesomeSvgIcon icon={faSearch} />
        </IconButton>
      ) : (
        <InputBase
          autoFocus
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={() => !value && setOpen(false)}
          sx={{
            bgcolor: "background.paper",
            borderRadius: 2,
            px: 2,
            py: 0.5,
            minWidth: 180,
            fontSize: 16,
            boxShadow: open ? 1 : 0,
          }}
          startAdornment={<FontAwesomeSvgIcon icon={faSearch} style={{ marginRight: "0.5rem" }} />}
        />
      )}
    </Box>
  );
};

export default React.memo(SearchToggle);
